// localStorage can throw (private mode, iframes with blocked storage on game portals).
// Losing a cached value is fine; crashing boot is not.

/** The player's name in this browser: the guest name, then the profile's name (T2.6). */
export const NAME_KEY = 'runkr.guestName'

export function readLocal(key: string): string | null {
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

export function writeLocal(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value)
  } catch {
    // ignore
  }
}

export function removeLocal(key: string): void {
  try {
    window.localStorage.removeItem(key)
  } catch {
    // ignore
  }
}
